import * as PIXI from 'pixi.js-legacy';
import productsService from '../products';
import { applicationSettings } from '../../settings/application';

const coreImageRoot = './images/core/';
const rangeImageRoot = `./images/${applicationSettings.applicationName.toLowerCase()}/`;

const coreImages = [
  {
    name: 'floor',
    url: `${coreImageRoot}floor.png`,
  },
  {
    name: 'drag_dot',
    url: `${coreImageRoot}drag_dot.png`,
  },
];

const rangeImages = {
  BROR: [
    {
      name: 'brace_64_black',
      url: `${rangeImageRoot}BROR_brace_64_black_0001.png`,
    },
    {
      name: 'brace_84_black',
      url: `${rangeImageRoot}BROR_brace_84_black_0001.png`,
    },
    {
      name: '110_back_left_black',
      url: `${rangeImageRoot}00333278_BROR_post_110_back_left_black_0001.png`,
    },
    {
      name: '110_back_right_black',
      url: `${rangeImageRoot}00333278_BROR_post_110_back_right_black_0001.png`,
    },
    {
      name: '110_back_right_over_black',
      url: `${rangeImageRoot}00333278_BROR_post_110_back_right_over_black_0001.png`,
    },
    {
      name: '110_front_left_black',
      url: `${rangeImageRoot}00333278_BROR_post_110_front_left_black_0001.png`,
    },
    {
      name: '110_front_right_black',
      url: `${rangeImageRoot}00333278_BROR_post_110_front_right_black_0001.png`,
    },
    {
      name: '190_back_left_black',
      url: `${rangeImageRoot}10333287_BROR_post_190_back_left_black_0001.png`,
    },
    {
      name: '190_back_right_black',
      url: `${rangeImageRoot}10333287_BROR_post_190_back_right_black_0001.png`,
    },
    {
      name: '190_back_right_over_black',
      url: `${rangeImageRoot}10333287_BROR_post_190_back_right_over_black_0001.png`,
    },
    {
      name: '190_front_left_black',
      url: `${rangeImageRoot}10333287_BROR_post_190_front_left_black_0001.png`,
    },
    {
      name: '190_front_right_black',
      url: `${rangeImageRoot}10333287_BROR_post_190_front_right_black_0001.png`,
    },
    {
      name: 'brace_84_grey_green',
      url: `${rangeImageRoot}BROR_brace_84_grey_green_0001.png`,
    },
    {
      name: '190_back_left_grey_green',
      url: `${rangeImageRoot}70547370_BROR_post_190_back_left_grey_green_0001.png`,
    },
    {
      name: '190_back_right_grey_green',
      url: `${rangeImageRoot}70547370_BROR_post_190_back_right_grey_green_0001.png`,
    },
    {
      name: '190_back_right_over_grey_green',
      url: `${rangeImageRoot}70547370_BROR_post_190_back_right_over_grey_green_0001.png`,
    },
    {
      name: '190_front_left_grey_green',
      url: `${rangeImageRoot}70547370_BROR_post_190_front_left_grey_green_0001.png`,
    },
    {
      name: '190_front_right_grey_green',
      url: `${rangeImageRoot}70547370_BROR_post_190_front_right_grey_green_0001.png`,
    },
    {
      name: 'brace_64_white',
      url: `${rangeImageRoot}BROR_brace_64_white_0001.png`,
    },
    {
      name: 'brace_84_white',
      url: `${rangeImageRoot}BROR_brace_84_white_0001.png`,
    },
    {
      name: '110_back_left_white',
      url: `${rangeImageRoot}30452613_BROR_post_110_back_left_white_0001.png`,
    },
    {
      name: '110_back_right_white',
      url: `${rangeImageRoot}30452613_BROR_post_110_back_right_white_0001.png`,
    },
    {
      name: '110_back_right_over_white',
      url: `${rangeImageRoot}30452613_BROR_post_110_back_right_over_white_0001.png`,
    },
    {
      name: '110_front_left_white',
      url: `${rangeImageRoot}30452613_BROR_post_110_front_left_white_0001.png`,
    },
    {
      name: '110_front_right_white',
      url: `${rangeImageRoot}30452613_BROR_post_110_front_right_white_0001.png`,
    },
    {
      name: '190_back_left_white',
      url: `${rangeImageRoot}10452614_BROR_post_190_back_left_white_0001.png`,
    },
    {
      name: '190_back_right_white',
      url: `${rangeImageRoot}10452614_BROR_post_190_back_right_white_0001.png`,
    },
    {
      name: '190_back_right_over_white',
      url: `${rangeImageRoot}10452614_BROR_post_190_back_right_over_white_0001.png`,
    },
    {
      name: '190_front_left_white',
      url: `${rangeImageRoot}10452614_BROR_post_190_front_left_white_0001.png`,
    },
    {
      name: '190_front_right_white',
      url: `${rangeImageRoot}10452614_BROR_post_190_front_right_white_0001.png`,
    },
    {
      name: '00382792:left',
      url: `${rangeImageRoot}00382792_BROR_addon_shelf_40_16_left_side_black_0001.png`,
    },
    {
      name: '00382792:right',
      url: `${rangeImageRoot}00382792_BROR_addon_shelf_40_16_right_side_black_0001.png`,
    },
    {
      name: '20402001:left',
      url: `${rangeImageRoot}20402001_BROR_addon_shelf_55_16_left_side_black_0001.png`,
    },
    {
      name: '20402001:right',
      url: `${rangeImageRoot}20402001_BROR_addon_shelf_55_16_right_side_black_0001.png`,
    },
  ],
  JONAXEL: [
    {
      name: 'frame_25_51_70_back_white',
      url: `${rangeImageRoot}JONAXEL_10429992_frame_25_51_70_back_white_0001.png`,
    },
    {
      name: 'frame_25_51_70_front_white',
      url: `${rangeImageRoot}JONAXEL_10429992_frame_25_51_70_front_white_0001.png`,
    },
    {
      name: 'cover_25_51_70_back',
      url: `${rangeImageRoot}JONAXEL_90429988_cover_25_51_70_open_back_white_0001.png`,
    },
    {
      name: 'cover_25_51_70_front',
      url: `${rangeImageRoot}JONAXEL_90429988_cover_25_51_70_open_front_white_0001.png`,
    },
    {
      name: 'frame_50_51_70_back_white',
      url: `${rangeImageRoot}JONAXEL_40419958_frame_50_51_70_back_white_0001.png`,
    },
    {
      name: 'frame_50_51_70_front_white',
      url: `${rangeImageRoot}JONAXEL_40419958_frame_50_51_70_front_white_0001.png`,
    },
    {
      name: 'frame_50_51_70_back_anthracite',
      url: `${rangeImageRoot}JONAXEL_90465882_frame_50_51_70_back_anthracite_0001.png`,
    },
    {
      name: 'frame_50_51_70_front_anthracite',
      url: `${rangeImageRoot}JONAXEL_90465882_frame_50_51_70_front_anthracite_0001.png`,
    },
    {
      name: 'cover_50_51_70_back',
      url: `${rangeImageRoot}JONAXEL_10419969_cover_50_51_70_open_back_white_0001.png`,
    },
    {
      name: 'cover_50_51_70_front',
      url: `${rangeImageRoot}JONAXEL_10419969_cover_50_51_70_open_front_white_0001.png`,
    },
    {
      name: 'frame_50_51_104_back_white',
      url: `${rangeImageRoot}JONAXEL_60419957_frame_50_51_104_back_white_0001.png`,
    },
    {
      name: 'frame_50_51_104_front_white',
      url: `${rangeImageRoot}JONAXEL_60419957_frame_50_51_104_front_white_0001.png`,
    },
    {
      name: 'cover_50_51_104_back',
      url: `${rangeImageRoot}JONAXEL_30419968_cover_50_51_104_open_back_white_0001.png`,
    },
    {
      name: 'cover_50_51_104_front',
      url: `${rangeImageRoot}JONAXEL_30419968_cover_50_51_104_open_front_white_0001.png`,
    },
    {
      name: 'legs_25_51_7_back',
      url: `${rangeImageRoot}JONAXEL_80419961_castors_and_legs_25_51_7_back_white_0001.png`,
    },
    {
      name: 'legs_25_51_7_front',
      url: `${rangeImageRoot}JONAXEL_80419961_castors_and_legs_25_51_7_front_white_0001.png`,
    },
    {
      name: 'legs_50_51_7_back',
      url: `${rangeImageRoot}JONAXEL_80419961_castors_and_legs_50_51_7_back_white_0001.png`,
    },
    {
      name: 'legs_50_51_7_front',
      url: `${rangeImageRoot}JONAXEL_80419961_castors_and_legs_50_51_7_front_white_0001.png`,
    },
  ],
  BOAXEL: [],
  AURDAL: [],
  IVAR: [],
  ELVARLI: [],
};

/**
 * Removes any images that have already been loaded as part of rangeImages.
 * Since the names do not necessarily match, an array relevantImageNames with manually entered names, is used
 * to determine which images should be removed.
 * @param {Array<Object>} imagesToLoad
 * @returns {Array<Object>}
 */
function removeAlreadyLoadedImages(imagesToLoad) {
  const relevantImageNames = ['castors_and_legs'];

  const isAlreadyLoadedImage = image => {
    return relevantImageNames.some(imageName => image.url.includes(imageName));
  };
  return imagesToLoad.filter(image => !isAlreadyLoadedImage(image));
}

export default function loadImages() {
  return dispatch => {
    return new Promise(resolve => {
      PIXI.Loader.shared
        .add(coreImages)
        .add(rangeImages[applicationSettings.applicationName])
        .add(removeAlreadyLoadedImages(productsService.getArticleImages()))
        .load(resolve);
    });
  };
}
